// v294b-image-components
import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { bgUrl } from './OptImg';

const API = process.env.REACT_APP_BACKEND_URL;

const shopImg = (path) => `https://www.trxl-performance.de/storage/images/image?remote=https%3A%2F%2Fwww.trxl-performance.de%2FWebRoot%2FStore31%2FShops%2F86566518%2F${path}&shop=86566518&width=800&height=800`;

const BASE_CATEGORIES = [
  {
    title: 'Sportauspuffe',
    subtitle: 'Grail, Remus, Milltek, Fox, Akrapovic',
    image: '/images/grail-exhaust-2.webp',
    link: '/shop?q=auspuff',
    cols: 7, rows: 2, height: '440px',
  },
  {
    title: 'Spoiler & Bodykits',
    subtitle: 'Maxton Design, Rieger, CSR, Ingo Noak',
    image: 'https://maxtondesign.com/cdn/shop/collections/ABS.png?v=1773734999&width=1500',
    link: '/shop?q=spoiler',
    cols: 5, rows: 1, height: '210px',
  },
  {
    title: 'Ladeluftkühler',
    subtitle: 'Wagner Tuning, HG-Motorsport, APR',
    image: shopImg('6932%2FCE15%2F4C2F%2F451B%2FA800%2F0A0C%2F6D12%2FF24A%2F200001077.jpg'),
    link: '/shop?q=ladeluftkuehler',
    cols: 5, rows: 1, height: '210px',
  },
  {
    title: 'Intake Systeme',
    subtitle: 'APR, E-Intake, Carbon Ansaugung',
    image: 'https://goapr-prod.nbg1.your-objectstorage.com/media/91/51/03/1699622590/ci100040_001.png',
    link: '/shop?q=intake',
    cols: 6, rows: 1, height: '280px', dark: true,
  },
  {
    title: 'Chiptuning',
    subtitle: 'Stage 1-3 für 1000+ Modelle',
    image: '/images/IMG_8433.JPG',
    link: 'https://chiptuning.trxl-performance.de/',
    cols: 6, rows: 1, height: '280px',
  },
];

// Wenn TyreSystem aktiv ist, zusätzliche Reifen/Felgen Karten anzeigen.
const TYRESYSTEM_CATEGORIES = [
  {
    title: 'Reifen',
    subtitle: 'Sommer, Winter, Ganzjahr · 100+ Marken',
    image: 'https://images.unsplash.com/photo-1568844293986-8d0400bd4745?auto=format&fit=crop&w=1200&q=80',
    link: '/reifen',
    internal: true,
    cols: 6, rows: 1, height: '280px',
  },
  {
    title: 'Felgen & Räder',
    subtitle: 'Alu- und Stahlfelgen, Komplettäder',
    image: 'https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?auto=format&fit=crop&w=1200&q=80',
    link: '/felgen',
    internal: true,
    cols: 6, rows: 1, height: '280px',
  },
];

const Categories = () => {
  const [categories, setCategories] = useState(BASE_CATEGORIES);

  useEffect(() => {
    fetch(`${API}/api/tyresystem/feature-flag`)
      .then(r => r.ok ? r.json() : { enabled: false })
      .then(d => {
        if (d.enabled) {
          setCategories([...BASE_CATEGORIES, ...TYRESYSTEM_CATEGORIES]);
        }
      })
      .catch(() => { });
  }, []);

  return (
  <section id="categories" className="section-lg" data-testid="categories-section">
    <div style={{ maxWidth: "1400px", margin: "0 auto", padding: "0 1.5rem" }}>
      <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
        style={{ marginBottom: '3rem' }}>
        <div className="caption" style={{ marginBottom: '1rem' }}>Unser Sortiment</div>
        <h2 className="heading-section" style={{ fontSize: 'clamp(2rem, 5vw, 3.5rem)' }}>
          Performance <span style={{ color: 'var(--primary)' }}>Kategorien</span>
        </h2>
      </motion.div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gap: '1rem' }} className="categories-grid">
        {categories.map((cat, i) => (
          <motion.a key={cat.title} href={cat.link}
            {...(cat.internal ? {} : { target: '_blank', rel: 'noopener noreferrer' })}
            data-testid={`category-${cat.title.toLowerCase().replace(/[\s&ü]/g, '-')}`}
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ delay: i * 0.08 }} whileHover={{ scale: 1.01 }}
            className={`cat-item cat-item-${i}`}
            style={{
              gridColumn: `span ${cat.cols}`,
              gridRow: `span ${cat.rows}`,
              position: 'relative', overflow: 'hidden', minHeight: cat.height,
              display: 'block', textDecoration: 'none', border: '1px solid rgba(255,255,255,0.06)',
              background: '#0a0a0a',
            }}>
            <div style={{
              position: 'absolute', inset: 0,
              backgroundImage: `url(${bgUrl(cat.image, 1200)})`,
              backgroundSize: cat.dark ? '70%' : 'cover',
              backgroundPosition: 'center', backgroundRepeat: 'no-repeat',
              transition: 'transform 0.8s ease',
              filter: cat.dark ? 'none' : 'brightness(0.5) contrast(1.1)',
            }} className="img-zoom" />
            {!cat.dark && <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.05) 50%)' }} />}
            <div style={{
              position: 'absolute', bottom: 0, left: 0, right: 0, padding: '1.5rem',
              display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end',
              background: cat.dark ? 'linear-gradient(to top, rgba(0,0,0,0.95), transparent)' : undefined,
            }}>
              <div>
                <h3 style={{ fontFamily: 'var(--font-heading)', fontWeight: 700, fontSize: cat.cols >= 7 ? '1.5rem' : '1.1rem', textTransform: 'uppercase', color: 'white', marginBottom: '0.25rem' }}>{cat.title}</h3>
                <p style={{ fontSize: '0.8rem', color: 'var(--fg-muted)' }}>{cat.subtitle}</p>
              </div>
              <div style={{ width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--primary)', color: 'white', flexShrink: 0 }}><ArrowUpRight size={18} /></div>
            </div>
          </motion.a>
        ))}
      </div>
    </div>
  </section>
  );
};

export default Categories;
